'use es6';

import { connect } from 'react-redux';
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import DroppableDummySection from './DroppableDummySection';
import { logInteraction } from 'LayoutBuilderUI/actions/ApiActions';
import { getIsSingleColumnFullWidth } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { getSelectedType } from 'EmailEditorUI/redux/selectors/selected';
import { repositionHubspotBrandingSection, selectHubspotBrandingSection } from 'LayoutBuilderUI/actions/layoutActions';
import ComponentToolbar from 'LayoutBuilderUI/components/toolbar/ComponentToolbar';
import ToolbarButton from 'EmailEditorUI/components/mo/visibility/ToolbarButton';
import { HUBSPOT_BRANDING_SECTION } from 'EmailEditorUI/constants/SidebarConstants';
import { ModuleRenderedContainer } from 'LayoutBuilderUI/components/editors/ModuleRenderedContainer';
import { getIsFileManagerOpen } from 'LayoutBuilderUI/selectors/userInterface';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { jsx as _jsx } from "react/jsx-runtime";
class HubspotBrandingSection extends Component {
  constructor(...args) {
    super(...args);
    this.onSelect = () => {
      logInteraction({
        action: 'Modify Layout Action',
        event: 'clicked-hubspot-branding-section'
      });
      return this.props.selectHubspotBrandingSection();
    };
    this.onAttemptDelete = () => {
      logInteraction({
        action: 'Modify Layout Action',
        event: 'attempt-remove-branding'
      });
      this.props.selectHubspotBrandingSection();
    };
    this.renderToolbar = () => {
      return /*#__PURE__*/_jsx(ComponentToolbar, {
        faded: false,
        type: "section",
        children: /*#__PURE__*/_jsx(ToolbarButton, {
          iconName: "delete",
          Icon: DeleteIcon,
          use: "tertiary",
          "data-test-id": "delete-section",
          onClick: this.onAttemptDelete,
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-editor-ui-shared.layoutBuilder.sections.removeBranding"
          })
        }, "remove")
      });
    };
  }
  componentDidUpdate(prevProps) {
    const {
      isSingleColumnFullWidth
    } = this.props;
    if (prevProps.isSingleColumnFullWidth !== isSingleColumnFullWidth) {
      this.props.repositionHubspotBrandingSection(isSingleColumnFullWidth);
    }
  }
  render() {
    const {
      lastSection,
      numSections,
      renderedModule,
      isSelected,
      isFileManagerOpen
    } = this.props;
    return /*#__PURE__*/_jsx(DroppableDummySection, {
      sectionForDrop: lastSection,
      sectionIndexForDrop: numSections - 1,
      dropAtStartOfEmail: false,
      numSections: numSections,
      id: "section_hubspot_brand",
      onSelect: this.onSelect,
      renderToolbar: this.renderToolbar,
      isSelected: isSelected,
      isFileManagerOpen: isFileManagerOpen,
      children: /*#__PURE__*/_jsx(ModuleRenderedContainer, {
        dangerouslySetInnerHTML: {
          __html: renderedModule
        }
      })
    });
  }
}
HubspotBrandingSection.propTypes = {
  lastSection: PropTypes.string,
  numSections: PropTypes.number,
  selectHubspotBrandingSection: PropTypes.func,
  renderedModule: PropTypes.string,
  isSelected: PropTypes.bool.isRequired,
  isSingleColumnFullWidth: PropTypes.bool.isRequired,
  repositionHubspotBrandingSection: PropTypes.func.isRequired,
  isFileManagerOpen: PropTypes.bool.isRequired
};
const mapStateToProps = state => {
  return {
    isSelected: getSelectedType(state) === HUBSPOT_BRANDING_SECTION,
    renderedModule: state.renderedModules['brandingSection'].getHtml(),
    isSingleColumnFullWidth: getIsSingleColumnFullWidth(state),
    isFileManagerOpen: getIsFileManagerOpen(state)
  };
};
const mapDispatchToProps = {
  selectHubspotBrandingSection,
  repositionHubspotBrandingSection
};
export default connect(mapStateToProps, mapDispatchToProps)(HubspotBrandingSection);